module.exports = __webpack_public_path__ + "img/selo_ambiental.9ffc392f.png";